import styled from 'styled-components';
import { Link as LinkBase } from 'react-router-dom';

import { cCC38FF } from '#/colors';

export const Link = styled(LinkBase)`
  display: block;
  margin-top: 10px;
  color: ${cCC38FF};
  font-weight: 500;
`;
